import React from 'react'

import Input from 'Components/Input'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default React.memo(props => <Title inline={props.inline} style={{padding: '5px 0'}} title={props.title} buttons={!props.disabled &&<button type="button" onClick={props.onClickSaisieLibreMultipleBool}
                                                       disabled={props.disabled || false}
                                                       className="text-success ei-commun_ajouter"
                                                       style={{display: 'inline-block', marginLeft: 5}}/>}>

        {
          (props.data !== undefined ? props.data : []).map((data, index) => (

            <Grid key={index} container style={{margin: 0, padding: 0}} spacing={0} justify={'center'}
                  alignItems={'center'}>
              <Grid item style={{margin: 0, padding: 0}}>
                <button type="button" onClick={() => props.onClickBoolSaisieLibreMultipleBool(index)}
                        disabled={props.disabled || false}
                        className={'ei-commun_pouce ei-' + (data.valeur_bool === true || data.valeur_bool === 1 || parseInt(data.valeur_bool) === 1 ? 'up primaryColor' : 'down secondaryColor')}/>
              </Grid>
              <Grid item xs style={{margin: 0, padding: 0}}>
                <Input style={props.style}
                  onChange={(e) => props.onChangeSaisieLibeMultipleBool(e, index)}
                  name={'text'}
                  disabled={props.disabled || false}
                  value={data.text !== undefined ? data.text : ""}
                />
              </Grid>
              <Grid item style={{margin: 0, padding: 0}}>
                <button type="button" onClick={() => props.onClickRemoveSaisieLibreMultipleBool(index)}
                        className="text-danger ei-commun_enlever"
                        disabled={props.disabled || false}/>
              </Grid>
            </Grid>
          ))
        }
      </Title>)


// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/SaisieLibreMultipleBool.js